import { ErrorDTO, PaymentOptionDTO, PromoCodeVerifiedResponseDTO } from "../../apiclient/ApiDtos";
import Either from "../../types/Either";

import { TentativeBookingReviewFsmContext } from "../review/TentativeBookingReviewFsmContext";

export class PaymentSelectionFsmContext {
    constructor(
        public readonly tentativeBookingReviewContext:TentativeBookingReviewFsmContext,
        public readonly isEnabledPromotionFeature: boolean,
        public readonly selectedPayment: SelectedPayment | null,
        public readonly paymentOptions: PaymentOptionDTO[]|null
    ) {}

    withPaymentOptions(paymentOptions: PaymentOptionDTO[]) {
        return new PaymentSelectionFsmContext(
            this.tentativeBookingReviewContext,
            this.isEnabledPromotionFeature,
            this.selectedPayment,
            paymentOptions
        )
    }

    withSelectedPaymentOption(paymentOption: PaymentOptionDTO) {
        return new PaymentSelectionFsmContext(
            this.tentativeBookingReviewContext,
            this.isEnabledPromotionFeature,
            new SelectedPayment(paymentOption, null, null),
            this.paymentOptions
        )
    }

    withoutSelectedPayment(){
        return new PaymentSelectionFsmContext(
            this.tentativeBookingReviewContext,
            this.isEnabledPromotionFeature,
            null,
            this.paymentOptions
        )
    }

    withVerifyingPromoCode(promo: string){
        
        return new PaymentSelectionFsmContext(
            this.tentativeBookingReviewContext,
            this.isEnabledPromotionFeature,
            this.selectedPayment? this.selectedPayment.withPromoCode(promo) : this.selectedPayment,
            this.paymentOptions
        )
    }

    withVerifiedPromoResult(result: Either<ErrorDTO, PromoCodeVerifiedResponseDTO>){
        return new PaymentSelectionFsmContext(
            this.tentativeBookingReviewContext,
            this.isEnabledPromotionFeature,
            this.selectedPayment? this.selectedPayment.withPromoResult(result) : this.selectedPayment,
            this.paymentOptions
        )
    }

    withoutPromo(){
        return new PaymentSelectionFsmContext(
            this.tentativeBookingReviewContext,
            this.isEnabledPromotionFeature,
            this.selectedPayment != null ? this.selectedPayment.withoutPromo() : this.selectedPayment,
            this.paymentOptions
        )
    }
}


export class SelectedPayment {
    constructor(
        public readonly paymentOption: PaymentOptionDTO,
        public readonly promoCode: string|null,
        public readonly promoAppliedResult: Either<ErrorDTO,PromoCodeVerifiedResponseDTO> | null
    ){}


    withPromoCode(promo: string) {
        return new SelectedPayment(this.paymentOption, promo, null)
    }

    withPromoResult(promoAppliedResult: Either<ErrorDTO,PromoCodeVerifiedResponseDTO>) {
        return new SelectedPayment(this.paymentOption, this.promoCode, promoAppliedResult)
    }

    withoutPromo(){
        return new SelectedPayment(this.paymentOption, null, null)
    }
}
